import request from "./request"

// const path = 'dj.api.'
const path2 = "dj.api.smartcarlife."

export function getList(data) {
  data.method = `${path2}ordermanage.page`
  return request(data)
}

export function exportFile(data) {
  data.method = `${path2}ordermanage.export`
  return request(data)
}

export function getOrderDetail(data) {
  data.method = `${path2}advanceOrder.detail`
  return request(data)
}

export function getOrderCount(data) {
  data.method = `${path2}ordermanage.count`
  return request(data)
}

// 待补录订单统计（交易记录条数，已补录数，待补录数）
export function waitinputorderCount(data) {
  data.method = `${path2}waitinputorder.count`
  return request(data)
}

// 待补录订单导出
export function waitinputorderExport(data) {
  data.method = `${path2}waitinputorder.export`
  return request(data)
}

// 分页查询待补录订单
export function waitinputorderPage(data) {
  data.method = `${path2}waitinputorder.page`
  return request(data)
}

// 订单导入
export function orderImport(data) {
  data.method = `${path2}order.import`
  return request(data, "post", ["file"])
}

// 订单导入结果查询
export function getImportResult(data) {
  // data.method = `${path2}order.getImportResult`
  data.method = `dj.api.common.importExcel.async.queryProcess`
  return request(data, "post")
}
// 订单模板下载
// export function downloadTemplate(data) {
//   data.method = `${path2}order.downloadTemplate`
//   return request(data, 'post')
// }

// 订单退款
export function markAsRefunded(data) {
  data.method = `${path2}goodsOrder.markAsRefunded`
  return request(data, "post")
}

// 待补录订单（批量修改流水所属园区店）
export function updateYqMerchant(data) {
  data.method = `${path2}waitinputorder.update.yqMerchant`
  return request(data, "post")
}

// 待补录订单（批量标记为无需补录）
export function markAsNoUse(data) {
  data.method = `${path2}waitinputorder.markAsNoUse`
  return request(data, "post")
}

// 众筹活动订单查询列表
export function shopmallOrderList(data) {
  data.method = `${path2}shopmallOrder.pageList`
  return request(data)
}

// 关联活动订单
export function relatedActivityOrder(data) {
  data.method = `${path2}waitinputorder.relatedActivityOrder`
  return request(data, "post")
}

// 取消待确认补录(更新为待补录)
export function batchUpdateToNotInput(data) {
  data.method = `${path2}waitinputorder.batchUpdateToNotInput`
  return request(data, "post")
}

// 待确认补录订单批量标记为确认补录
export function batchUpdateConfirmInput(data) {
  data.method = `${path2}waitinputorder.batchUpdateConfirmInput`
  return request(data, "post")
}

// 订单详情
export function goodsOrderDetail(data) {
  data.method = `${path2}goodsOrder.detail`
  return request(data, "post")
}

// 获取订单分账规则
export function getHistoryEffectRecord(data) {
  // data.method = `${path2}getHistoryEffectRecord`
  data.method = `${path2}merchantEffectRule.effective.list`
  return request(data, "post")
}

// 待补录订单手动分账
export function manualDivision(data) {
  data.method = `${path2}waitinputorder.manualDivision`
  return request(data, "post")
}

// 待补录订单分账记录
export function getDivisionRecordById(data) {
  data.method = `${path2}getDivisionRecordById`
  return request(data, "post")
}
// 根据园区店商户号获取4s列表
export function getServiceStore(data) {
  data.method = "dj.api.scenemerchantref.query4SRefByYqShop"
  return request(data, "post")
}

// 订单分账记录
export function getDivisionRecordByOrderCode(data) {
  data.method = `${path2}getDivisionRecordByOrderCode`
  return request(data, "post")
}

// 取消分账
export function cancelDivideAccountsAPI(data) {
  data.method = `${path2}order.cancelProfitAllocation`
  return request(data, "post")
}

// 配置升级订单-订单核销
export function verification(data) {
  data.method = `${path2}configUpgradeOrder.verification`
  return request(data, "post")
}

// 配置升级订单-退款
export function refund(data) {
  data.method = `${path2}configUpgradeOrder.refund`
  return request(data, "post")
}

// 订单管理excel导出表头字段模板
export function exportHeadTemplate(data) {
  data.method = `${path2}ordermanage.export.head.template`
  return request(data, "post")
}

// 标记开票订单
export function markAsInvoiced(data) {
  data.method = `${path2}goodsOrder.markAsInvoiced`
  return request(data, "post")
}

// 超管修改备注
export function modifyRemark(data) {
  data.method = `${path2}goodsOrder.modifyRemark`
  return request(data, "post")
}
